export const pairingData = {
  aries: {
    taurus: { score: 70, text: '白羊座和金牛座是很有趣的组合，一个快，一个慢，需要双方的耐心和努力来维持关系。' },
    gemini: { score: 90, text: '白羊座和双子座都充满活力和好奇心，他们在一起会非常有趣，是天作之合。' },
    cancer: { score: 50, text: '白羊的直率可能会伤害到敏感的巨蟹，需要白羊学习温柔，巨蟹学习坚强。' },
    leo: { score: 100, text: '两个火象星座，一拍即合！充满激情和活力的组合，是天生一对。' },
    virgo: { score: 65, text: '白羊的大大咧咧和处女座的一丝不苟形成反差，需要互相适应。' },
    libra: { score: 85, text: '对宫星座，有致命的吸引力。白羊的果断和天秤的优雅可以互补。' },
    scorpio: { score: 75, text: '充满挑战的组合，双方都很有个性，关系充满激情但也可能充满冲突。' },
    sagittarius: { score: 95, text: '同为火象星座，你们是理想的玩伴和伴侣，生活充满乐趣。' },
    capricorn: { score: 60, text: '白羊的冲动和摩羯的稳重截然不同，需要双方都付出很多努力。' },
    aquarius: { score: 80, text: '你们都是独立、有主见的星座，能够互相理解，是很不错的搭配。' },
    pisces: { score: 70, text: '白羊的强势和双鱼的温柔可以互补，但也要注意沟通，避免误解。' }
  },
  taurus: {
    gemini: { score: 60, text: '金牛座的稳定和双子座的多变形成对比，需要很多沟通才能和谐相处。' },
    cancer: { score: 90, text: '同为重视家庭和安全的星座，你们的组合非常和谐，能给彼此带来温暖。' },
    leo: { score: 70, text: '金牛的务实和狮子的奢华需要磨合，但如果能互相欣赏，也是不错的组合。' },
    virgo: { score: 100, text: '两个土象星座，价值观相似，相处起来非常踏实、和谐，是天作之合。' },
    libra: { score: 80, text: '你们都追求美和和谐，品味相近，是很优雅的一对。' },
    scorpio: { score: 85, text: '对宫星座，充满了强烈的吸引力，但也可能因为固执而产生冲突。' },
    sagittarius: { score: 55, text: '金牛的安稳和射手的自由形成强烈对比，需要极大的包容心。' },
    capricorn: { score: 95, text: '同为土象星座，你们的目标一致，能够共同努力，创造美好的未来。' },
    aquarius: { score: 60, text: '金牛的传统和水瓶的革新思想很难调和，是充满挑战的组合。' },
    pisces: { score: 90, text: '金牛的稳定能给双鱼带来安全感，双鱼的浪漫能给金牛的生活增添色彩。' }
  },
  gemini: {
    cancer: { score: 70, text: '双子的多变和巨蟹的敏感需要小心翼翼地相处，沟通是关键。' },
    leo: { score: 85, text: '你们都是爱玩、爱热闹的星座，在一起会充满欢声笑语。' },
    virgo: { score: 60, text: '双子的随性和处女的严谨是很大的挑战，需要双方都做出改变。' },
    libra: { score: 100, text: '同为风象星座，你们沟通无障碍，是灵魂伴侣，天生一对。' },
    scorpio: { score: 50, text: '双子的轻快和天蝎的深刻很难相容，是需要奇迹才能维持的组合。' },
    sagittarius: { score: 85, text: '对宫星座，你们都热爱自由和探索，能成为最好的旅伴。' },
    capricorn: { score: 55, text: '双子的善变和摩羯的责任感格格不入，需要很强的责任心来维持。' },
    aquarius: { score: 95, text: '同为风象星座，你们都是思想家，能进行有趣的智力交流，非常合拍。' },
    pisces: { score: 65, text: '双子的理性和双鱼的感性需要找到平衡点，否则容易产生误解。' }
  },
  cancer: {
    leo: { score: 80, text: '巨蟹的温柔能包容狮子的霸道，狮子的阳光能温暖巨蟹的内心。' },
    virgo: { score: 90, text: '巨蟹的情感和处女的细致能很好地结合，是互相扶持、共同成长的组合。' },
    libra: { score: 65, text: '巨蟹的居家和天秤的社交需求不同，需要找到家庭和外界的平衡。' },
    scorpio: { score: 100, text: '同为水象星座，你们能深刻理解对方的情感，是心意相通的一对。' },
    sagittarius: { score: 60, text: '巨蟹的恋家和射手的爱自由是天生的矛盾，需要双方的努力和妥协。' },
    capricorn: { score: 85, text: '对宫星座，巨蟹的感性和摩羯的理性互补，能建立稳定而深刻的关系。' },
    aquarius: { score: 50, text: '巨蟹的情感需求和水瓶的疏离感很难调和，是充满挑战的组合。' },
    pisces: { score: 95, text: '同为水象星座，你们都非常感性，能沉浸在彼此的浪漫世界里。' }
  },
  leo: {
    virgo: { score: 70, text: '狮子的光芒可能会让处女座感到压力，但处女的细心也能帮助狮子变得更完美。' },
    libra: { score: 90, text: '狮子的热情和天秤的优雅相得益彰，你们是社交场合中最亮眼的一对。' },
    scorpio: { score: 75, text: '两个王者星座，关系充满激情和戏剧性，但也可能因为控制欲而产生冲突。' },
    sagittarius: { score: 95, text: '同为火象星座，你们对生活有同样的热情，是绝佳的玩伴和伴侣。' },
    capricorn: { score: 60, text: '狮子的奢华和摩羯的朴实是两种不同的价值观，需要互相尊重。' },
    aquarius: { score: 85, text: '对宫星座，狮子的个人主义和水瓶的集体主义可以互相启发，带来成长。' },
    pisces: { score: 65, text: '狮子的阳光和双鱼的敏感需要小心呵护，狮子要学习温柔，双鱼要学习表达。' }
  },
  virgo: {
    libra: { score: 80, text: '处女的细致和天秤的审美很合拍，你们都追求高品质的生活。' },
    scorpio: { score: 85, text: '处女的分析能力和天蝎的洞察力能产生奇妙的化学反应，是深刻的灵魂伴侣。' },
    sagittarius: { score: 50, text: '处女的计划性和射手的即兴发挥格格不入，是充满挑战的组合。' },
    capricorn: { score: 100, text: '同为土象星座，你们都非常务实，能共同为目标奋斗，是完美的搭档。' },
    aquarius: { score: 60, text: '处女的逻辑和水瓶的跳跃性思维很难同步，需要更多的耐心。' },
    pisces: { score: 85, text: '对宫星座，处女的务实能给双鱼带来安定，双鱼的浪漫能软化处女的心。' }
  },
  libra: {
    scorpio: { score: 70, text: '天秤的平和和天蝎的激烈需要磨合，但天蝎的深刻能吸引天秤去探索。' },
    sagittarius: { score: 90, text: '你们都热爱社交和自由，能成为彼此最好的朋友和情人。' },
    capricorn: { score: 65, text: '天秤的随和和摩羯的严谨是两种不同的生活态度，需要找到共同点。' },
    aquarius: { score: 95, text: '同为风象星座，你们是思想上的知己，能享受无尽的有趣对话。' },
    pisces: { score: 75, text: '天秤的理性和双鱼的感性可以互补，能创造出充满艺术气息的关系。' }
  },
  scorpio: {
    sagittarius: { score: 70, text: '天蝎的占有欲和射手的自由是主要的矛盾点，需要双方的信任。' },
    capricorn: { score: 90, text: '天蝎的深刻和摩羯的稳重能建立起非常强大和忠诚的关系。' },
    aquarius: { score: 75, text: '你们都非常固执，是充满挑战的组合，但也可能因为互相的智慧而吸引。' },
    pisces: { score: 95, text: '同为水象星座，你们能深刻地理解对方，是灵魂层面的伴侣。' }
  },
  sagittarius: {
    capricorn: { score: 60, text: '射手的乐观和摩羯的悲观是鲜明对比，需要射手带动摩羯。' },
    aquarius: { score: 90, text: '你们都热爱自由和创新，能一起探索世界的无限可能。' },
    pisces: { score: 50, text: '射手的直率可能会无意中伤害到双鱼的敏感，是需要小心经营的关系。' }
  },
  capricorn: {
    aquarius: { score: 70, text: '摩羯的传统和水瓶的现代感需要磨合，但都能欣赏对方的智慧。' },
    pisces: { score: 85, text: '摩羯的稳定能给双鱼提供依靠，双鱼的温柔能融化摩羯的心。' }
  },
  aquarius: {
    pisces: { score: 75, text: '水瓶的理性和双鱼的感性是很好的互补，能一起进行精神层面的探索。' }
  }
};

export const getPairing = (c1, c2) => {
  if (!c1 || !c2) return null;
  const sortedNames = [c1, c2].sort();
  const [first, second] = sortedNames;
  return pairingData[first]?.[second] || { score: 50, text: '这是一个独特的组合，充满了无限的可能性。' };
};
